import { FileTextOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Typography } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useConfig } from "../../contexts/ConfigContext";
import { useIsMobile } from "../../hooks/useIsMobile";

const UserMenu = () => {
  const { currentUser, logout } = useAuth();
  const { activeEnv, country } = useConfig();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // Dónde se está trabajando, arriba del todo.
  //
  // El distintivo de la cabecera enseña la empresa recortada y en móvil se
  // pliega; acá va el dato exacto, que es el que hace falta cuando se sospecha
  // que el terminal apunta a otro sitio.
  const entorno = activeEnv?.company || activeEnv?.env;

  // Opciones del menú
  const items = [
    ...(entorno
      ? [
          {
            key: "entorno",
            type: "group",
            label: (
              <div style={{ maxWidth: 240, whiteSpace: "normal", padding: "2px 0" }}>
                <Typography.Text strong>{activeEnv?.company || "Sin empresa"}</Typography.Text>
                <br />
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {activeEnv?.env || "sin corporativo"}
                </Typography.Text>
                <br />
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {country?.name || activeEnv?.country || "sin país"}
                </Typography.Text>
              </div>
            ),
          },
          { type: "divider" },
        ]
      : []),
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Mi perfil",
      onClick: () => navigate("/perfil"),
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Configuración",
      onClick: () => navigate("/configuracion"),
    },
    {
      key: "release-notes",
      icon: <FileTextOutlined />,
      label: "Notas de la versión",
      onClick: () => navigate("/notas-version"),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Cerrar Sesión",
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
      <Button
        type="text"
        style={{
          color: "white",
          width: isMobile ? 32 : "auto",
          height: isMobile ? 32 : 32,
          padding: isMobile ? 0 : "0 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <UserOutlined style={{ fontSize: isMobile ? 16 : 14 }} />
        {!isMobile && <span style={{ marginLeft: 8 }}>{currentUser.firstName}</span>}
      </Button>
    </Dropdown>
  );
};

export default UserMenu;
